import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const homePage = PageBlueprint.make({
  params: {
    path: '/',
    title: 'Home',
    loader: () =>
      import('./HomePage').then(m => <m.HomePage />),
    noHeader: true,
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homePage],
});
